import userAction from '/src/features/user/actions/userAction';
import urlWithRoutingCompany from './urlWithRoutingCompany';
const { changeCompany } = userAction;

export const switchCompany = async (id, navigate) => {
    const res = await changeCompany(id);
    if (res.error != null) {
        return;
    }
    navigate(urlWithRoutingCompany('home'));
};